/**
 * @tabler/icons-react v2.25.0 - MIT
 */
import createReactComponent from '../createReactComponent.js';
var IconAlertTriangleFilled = createReactComponent("alert-triangle-filled", "IconAlertTriangleFilled", [["path", {
  d: "M11.94 2a2.99 2.99 0 0 1 2.45 1.279l.108 .164l8.431 14.074a2.989 2.989 0 0 1 -2.366 4.474l-.2 .009h-16.856a2.99 2.99 0 0 1 -2.648 -4.308l.101 -.189l8.425 -14.065a2.989 2.989 0 0 1 2.555 -1.438zm.07 14l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z",
  fill: "currentColor",
  key: "svg-0",
  strokeWidth: "0"
}]]);
export { IconAlertTriangleFilled as default };